import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const ContactUsForm = () => {
  // 🔹 State
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);

  // 🔹 This must be defined INSIDE the component
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // 🔹 Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(null);

    // validation
    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.address
    ) {
      alert("Please fill all required fields!");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://s-ten-ochre.vercel.app/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error("Failed to send message");

      setSuccess(true);
      setFormData({ name: "", phone: "", email: "", address: "", message: "" });
    } catch (error) {
      console.error(error);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 pb-12">
      <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-2xl shadow-2xl p-10 text-white">
        <div className="flex items-center space-x-3 mb-10">
          <div className="flex items-center justify-center w-12 h-12 bg-accent rounded-lg shadow-lg">
            <Icon
              name="MessageCircle"
              size={24}
              color="white"
              strokeWidth={2}
            />
          </div>
          <div>
            <h2 className="text-3xl font-bold">Let’s Talk</h2>
            <p className="text-sm text-gray-300">
              Fill in your details and we’ll get back to you ASAP.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { id: "name", label: "Your Name", icon: "User" },
              { id: "phone", label: "Phone Number", icon: "Phone" },
              { id: "email", label: "Email Address", icon: "Mail" },
              { id: "address", label: "Your Address", icon: "MapPin" },
            ].map((field) => (
              <div
                key={field.id}
                className="flex items-center space-x-3 bg-slate-800/70 rounded-xl p-4 border border-slate-700 focus-within:border-accent transition-all"
              >
                <Icon name={field.icon} size={18} className="text-accent" />
                <input
                  type={field.id === "email" ? "email" : "text"}
                  id={field.id}
                  name={field.id}
                  value={formData[field.id]}
                  onChange={handleChange} // ✅ defined in same scope
                  placeholder={field.label}
                  required
                  className="w-full bg-transparent outline-none text-sm placeholder-gray-400"
                />
              </div>
            ))}
          </div>

          <div className="bg-slate-800/70 rounded-xl p-4 border border-slate-700 focus-within:border-accent transition-all">
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Write your message here..."
              rows={5}
              className="w-full bg-transparent outline-none text-sm placeholder-gray-400 resize-none"
            />
          </div>

          <Button
            type="submit"
            variant="default"
            fullWidth
            iconName="Send"
            iconPosition="right"
            disabled={loading}
            className="bg-accent hover:bg-accent/90 text-white py-3 rounded-xl shadow-xl transition-transform hover:scale-[1.02]"
          >
            {loading ? "Sending..." : "Send Message"}
          </Button>
        </form>

        <div className="mt-8 text-center text-sm">
          {success === true && (
            <p className="text-green-400">✅ Message sent successfully!</p>
          )}
          {success === false && (
            <p className="text-red-400">
              ❌ Failed to send message. Try again.
            </p>
          )}
          {success === null && (
            <p className="text-gray-400">
              💡 We usually reply within{" "}
              <span className="text-accent">24 hours</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUsForm;
